// import { CategoriesComponent } from './../pages/products/categories/categories.component'; new
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule,} from '@angular/material/button';
import { MatButtonToggleModule,} from '@angular/material/button-toggle';
import { MatCardModule,} from '@angular/material/card';
import { MatCheckboxModule,} from '@angular/material/checkbox';
import { MatChipsModule,} from '@angular/material/chips';
import { MatDatepickerModule,} from '@angular/material/datepicker';
import { MatDialogModule,} from '@angular/material/dialog';
import { MatExpansionModule,} from '@angular/material/expansion';
import { MatGridListModule,} from '@angular/material/grid-list';
import { MatIconModule,} from '@angular/material/icon';
import { MatInputModule,} from '@angular/material/input';
import { MatListModule,} from '@angular/material/list';
import { MatMenuModule,} from '@angular/material/menu';
import { MatNativeDateModule} from '@angular/material/core';
import { MatPaginatorModule,} from '@angular/material/paginator';
import { MatProgressBarModule,} from '@angular/material/progress-bar';
import { MatProgressSpinnerModule,} from '@angular/material/progress-spinner';
import { MatRadioModule,} from '@angular/material/radio';
import { MatRippleModule,} from '@angular/material/core';
import { MatSelectModule,} from '@angular/material/select';
import { MatSidenavModule,} from '@angular/material/sidenav';
import { MatSliderModule,} from '@angular/material/slider';
import { MatSlideToggleModule,} from '@angular/material/slide-toggle';
import { MatSnackBarModule,} from '@angular/material/snack-bar';
import { MatSortModule,} from '@angular/material/sort';
import { MatTableModule,} from '@angular/material/table';
import { MatTabsModule,} from '@angular/material/tabs';
import { MatToolbarModule,} from '@angular/material/toolbar';
import { MatTooltipModule,} from '@angular/material/tooltip';
import { MatStepperModule,} from '@angular/material/stepper';
import { MatBadgeModule } from '@angular/material/badge';
import { NgxStripeModule } from 'ngx-stripe';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SearchProductsComponent } from './search-products/search-products.component';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true               
};

import { PipesModule } from '../theme/pipes/pipes.module';
import { RatingComponent } from './rating/rating.component';
import { ControlsComponent } from './controls/controls.component';
import { MainCarouselComponent } from './main-carousel/main-carousel.component';
import { BrandsCarouselComponent } from './brands-carousel/brands-carousel.component';
import { ProductsCarouselComponent } from './products-carousel/products-carousel.component';
import { ProductDialogComponent } from './products-carousel/product-dialog/product-dialog.component';
import { BannersComponent } from './banners/banners.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupComponent } from '../theme/components/popup/popup.component';
import { DeliveryCalendarComponent } from './delivery-calendar/delivery-calendar.component';
import { TopMenuComponent } from '../theme/components/top-menu/top-menu.component';
import { AccountSideMenuComponent } from '../theme/components/account-side-menu/account-side-menu.component';
import { ImagePreloadDirective } from './directive/image-preload.directive';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { MatProgressButtonsModule } from 'mat-progress-buttons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// import { HomeComponent } from './../pages/home/home.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SidenavMenuComponent } from '../theme/components/sidenav-menu/sidenav-menu.component';
import { PreCartComponent } from './cart/pre-cart/pre-cart.component';
import { CartDialogComponent } from './cart/cart-dialog/cart-dialog.component';
import { DeleteCartComponent } from './cart/delete-cart/delete-cart.component';
import { SkipStopRecurringComponent } from './cart/skip-stop-recurring/skip-stop-recurring.component';
import { NotFoundComponent } from '../main-theme/global-theme/pages/not-found/not-found.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { DesktopMenuComponent } from '../theme/components/desktop-menu/desktop-menu.component';
import { HeaderComponent } from '../main-theme/global-theme/header/header.component';
import { FooterComponent } from '../main-theme/global-theme/footer/footer.component';
import { OrderSummaryComponent } from '../theme/components/order-summary/order-summary.component';
import { CcAlertComponent } from '../theme/components/cc-alert/cc-alert.component';
import { ProductsComponent } from '../main-theme/global-theme/pages/products/products.component';
import { ProductZoomComponent } from '../main-theme/global-theme/pages/products/product/product-zoom/product-zoom.component';
import { CategoriesComponent } from '../main-theme/global-theme/pages/products/categories/categories.component';
import { HomeComponent } from '../main-theme/global-theme/pages/home/home.component';
import { ProductComponent } from '../main-theme/global-theme/pages/products/product/product.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { CategoryGridComponent } from '../main-theme/global-theme/pages/category-grid/category-grid/category-grid.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    // ExperimentalScrollingModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    PerfectScrollbarModule,
    PipesModule,
    FormsModule,
    ScrollingModule,
    ReactiveFormsModule,
    MatBadgeModule,
    NgxSkeletonLoaderModule,
    MatDividerModule,
    MatFormFieldModule,
    OverlayModule,
    MatProgressButtonsModule.forRoot(),
    NgxStripeModule.forRoot(),
    NgxPaginationModule,
    NgxImageZoomModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    PerfectScrollbarModule,
    // ExperimentalScrollingModule,
    PipesModule,
    FormsModule,
    ScrollingModule,
    ReactiveFormsModule,
    MatProgressButtonsModule,
    NgxSkeletonLoaderModule,
    NgxStripeModule,
    NgxPaginationModule,
    NgxImageZoomModule,
    
    SidenavMenuComponent,
    OverlayModule,
    RatingComponent,
    ControlsComponent,
    MainCarouselComponent,
    BrandsCarouselComponent,
    ProductsCarouselComponent,
    ProductDialogComponent,
    CartDialogComponent,
    DeleteCartComponent,
    SkipStopRecurringComponent,
    BannersComponent,
    PopupComponent,
    CategoryListComponent,
    // CategoriesComponent, new
    MatBadgeModule,
    DeliveryCalendarComponent,
    TopMenuComponent,
    DesktopMenuComponent,
    AccountSideMenuComponent,
    SearchProductsComponent,
    // HomeComponent,
    ImagePreloadDirective,
    NotFoundComponent,
    HeaderComponent,
    FooterComponent,
    OrderSummaryComponent,
    CcAlertComponent,

    ProductsComponent,
    ProductComponent,
    ProductZoomComponent,
    CategoriesComponent,
    HomeComponent,
    CategoryGridComponent,
    // PreCartComponent,

  ],
  declarations: [
    SidenavMenuComponent,
    RatingComponent,
    ControlsComponent,
    MainCarouselComponent,
    BrandsCarouselComponent,
    ProductsCarouselComponent,
    ProductDialogComponent,
    CartDialogComponent,
    DeleteCartComponent,   
    SkipStopRecurringComponent, 
    BannersComponent,
    CategoryListComponent,
    // CategoriesComponent, new
    // HomeComponent,
    PopupComponent,
    DeliveryCalendarComponent,
    TopMenuComponent,
    DesktopMenuComponent,
    AccountSideMenuComponent,
    SearchProductsComponent,
    ImagePreloadDirective,
    // PreCartComponent,
    NotFoundComponent,
    HeaderComponent,
    FooterComponent,
    OrderSummaryComponent,
    CcAlertComponent,

    ProductsComponent,
    ProductComponent,
    ProductZoomComponent,
    CategoriesComponent,
    HomeComponent,
    CategoryGridComponent,
  ],
  entryComponents:[
    ProductDialogComponent,
    CartDialogComponent,
    DeleteCartComponent,
    SkipStopRecurringComponent,
    PopupComponent,
  ],
  providers:[
    DatePipe,
    CurrencyPipe,
    // { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ]
})
export class SharedModule { }
